import * as React from "react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";

export function FeedbackButton({ onOpen, isOpen, className, ...props }) {
  return (
    <Button
      onClick={onOpen}
      className={cn(
        // Base styles
        "z-[10] fixed right-0 top-1/2 -translate-y-1/2",
        "h-auto px-2 py-6 rounded-l-lg rounded-r-none",
        "bg-white text-black hover:bg-gray-100", // 흰색 배경, 검은색 글씨, 호버 시 연한 회색
        "transition-all duration-300 ease-in-out",
        // Text styles
        "writing-mode-vertical tracking-widest uppercase font-medium text-sm",
        // Transform styles for open state
        isOpen
          ? "translate-x-[calc(400px-2px)] border-r-2 border-gray-300 rounded-none"
          : "translate-x-0",
        className
      )}
      style={{
        writingMode: "vertical-lr",
        textOrientation: "mixed",
      }}
      {...props}
    >
      Feedback
    </Button>
  );
}
